const SvgSwapVert = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M20.667 22.68v-9.347h-1.333v9.347h-4.667L20 28l5.333-5.32zM12 4 6.667 9.32h4.667v9.347h1.333V9.32H18zm8.667 18.68v-9.347h-1.333v9.347h-4.667L20 28l5.333-5.32zM12 4 6.667 9.32h4.667v9.347h1.333V9.32H18z" />
  </svg>;
export default SvgSwapVert;